import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface Result {
  resolveAlert: boolean;
}

export const resolveAlert = async <V>(
  apollo: DollarApollo<V>,
  alertId: string
): Promise<FetchResult<Result>> => {
  const result = apollo.mutate({
    mutation: Mutation,
    variables: { alertId }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
